<template id="crossfilter-page">
    <section>
        <div class="row" v-for="r of rows" v-bind:key="r">
            <div v-for="c of rowColMap[r]" v-bind:key="c" :class="'text-center ml-3 mt-4 '+makeWidth(r, c)">
                <crossfilter :crossfilter="vizDataRowCol[r][c][0]"></crossfilter>
            </div>
        </div>
    </section>
</template>
<script>
import Crossfilter from '@/components/crossfilter'
import _ from 'lodash'

export default {
        name: "crossfilter-page",
        components: {Crossfilter},
        data: () => ({
            searching: false,
            vizData: [],
            vizDataRowCol: {},
            rows: [],
            rowColMap: {}
        }),
        computed: {},
        created() {
            this.loadSummary()
            this.listenToRouter()
        },
        methods: {
            makeWidth: function (r, c) {
                let v0 = this.vizDataRowCol[r][c][0].vizunitWidthArray
                let defV = ['2', '4', '5']
                let v = v0 && v0.length > 0 ? v0 : defV
                let lg = v[2], md = v[1], sm = v[0]
                return `col-lg-${lg} col-md-${md} col-sm-${sm}`
            },
            loadSummary: function () {
                console.info('loading summary')
                let menuParam = this.$route.params.menuId
                let submenuParam = this.$route.params.submenuId
              console.log('cf', 'load state'); this.$store.dispatch("loadState").then(() => {
                    let allVizData = this.$store.state.fwScreenConfig

                //    let vizData = allVizData.filter(r => r.menuId === menuParam && r.subMenuId === submenuParam)
                    let vizData = allVizData.filter(r => r.menuId === submenuParam)
                    if (vizData.length === 0) {
                        console.error("No vizdata for the screen, hence Blank Screen..fix data", vizData, vizData.length)
                        return
                    }
                    console.log("Visualization Data", vizData, vizData.length)
                    this.menuName = this.$store.state.menuMasterData.filter(m => m.menuId === menuParam).map(m => m.menuName)[0]
                    this.screenName = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam).map(m => m.menuName)[0]
                    this.menusyspk = this.$store.state.menuMasterData.filter(m => m.menuId === menuParam).map(m => m.syspk)[0]

                    console.log("menusyspk",this.menusyspk)

                    //what we'll do is identify the max rows
                    //then for each row identify the max cols
                    let maxRows = _.max(vizData.map(v => v.positionRow)) + 1
                    let rowColMap = {}
                    _.range(1, maxRows).forEach(rowNum => {
                        rowColMap[rowNum] = _.range(1, _.max(vizData.filter(v => v.positionRow === rowNum).map(v => v.positionColumn)) + 1)
                    })

                    this.rows = _.range(1, maxRows)
                    this.rowColMap = rowColMap
                    let vizDataRowCol = {}
                    _.forEach(rowColMap, (colCount, rowNumStr) => {
                        let rowNum = +rowNumStr
                        vizDataRowCol[rowNum] = {}
                        let rowData = vizData.filter(v => v.positionRow === rowNum)
                        rowColMap[rowNum].forEach(colNum => {
                            vizDataRowCol[rowNum][colNum] = rowData.filter(v => v.positionColumn === colNum)
                        })

                    })
                    this.vizDataRowCol = vizDataRowCol
                    //log the event in audi log
                    //this.$commonFn.auditLog(this.menuName, this.screenName, "", "GET", "Success")
                    this.$commonFn.auditLog(this.menusyspk,submenuParam,this.menuName,this.screenName, "GET", "Success")
                }, err => {
                    console.error("error in getting he crossfilter data", err)
                })
            },
            listenToRouter: function () {
                let $this = this
                this.$router.afterEach(function (from, to) {
                    console.log(`router moved to ${from.path} from ${to.path}, crossfilter crossfilter = ${$this.rows.length}`)
                    $this.rows = []
                    setTimeout(() => {
                        $this.loadSummary()
                    }, 300)

                })
            }
        }
    }
</script>